module.exports = __webpack_public_path__ + "img/next_to_coast_low_lying.b154dc2c.jpg";